/* unplugin-vue-components disabled */import { render } from "./LegacyVideoChapterPlayer.vue?vue&type=template&id=7076e014&scoped=true&ts=true"
import script from "./LegacyVideoChapterPlayer.vue?vue&type=script&lang=ts"
export * from "./LegacyVideoChapterPlayer.vue?vue&type=script&lang=ts"

import "./LegacyVideoChapterPlayer.vue?vue&type=style&index=0&id=7076e014&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7076e014"]])

export default __exports__